
export const LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'USER_LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';

export const CHANGE_MSG_COUNT = 'CHANGE_MSG_COUNT';